module.exports = __webpack_public_path__ + "static/media/ic_huodong.c13871f7.svg";